<script setup lang="ts">
/**
 * An icon-only button whose accessible name is a REQUIRED prop: an icon-only
 * control with no name is a dead control, and here that is a type error rather
 * than a review comment (ADR-0247, after `@axon/ui`'s `IconButton`).
 *
 * `label` becomes `aria-label`; `title` is the tooltip, separate on purpose.
 */
withDefaults(
  defineProps<{
    /** Required: an icon-only control with no accessible name is a dead control. */
    readonly label: string;
    readonly title?: string | undefined;
    readonly variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | undefined;
    readonly size?: 'sm' | 'md' | 'lg' | undefined;
  }>(),
  { variant: 'ghost', size: 'md' },
);

const emit = defineEmits<{ click: [] }>();
</script>

<template>
  <button
    type="button"
    :class="['ow-button', 'ow-button--icon', `ow-button--${variant}`, `ow-button--${size}`]"
    :aria-label="label"
    :title="title"
    @click="emit('click')"
  >
    <slot />
  </button>
</template>
